<template>
  <div class="section-main__warp firePatrol__wrap">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="status" slot-scope="scope">
        <el-switch
          v-model="scope.row.status"
          :active-value="'1'"
          :inactive-value="'2'"
          @change="handleUpdateStatus(scope.row)"
        ></el-switch>
        {{ scope.row.status == 1 ? "启用" : "禁用" }}
      </template>
      <template slot="firePatrolCode" slot-scope="scope">
        <span @click="showCode(scope.row)">
          <vue-qr
            style="cursor: pointer"
            :text="
              h5Url +
              scope.row.firePatrolCode +
              '&firePatrolName=' +
              scope.row.firePatrolName
            "
            :logoSrc="icon"
            :size="40"
            :margin="0"
          ></vue-qr>
        </span>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAdd"
        >
          新增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          v-if="scope.row.status == 2"
          class="item"
          effect="dark"
          content="编辑"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            @click="handleEdit(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          v-if="scope.row.status == 2"
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-shanchu"
            @click="handleDel(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>

    <!-- 新增/编辑弹窗 -->
    <addItems ref="refAddItems" @handleUpdate="handleUpdate" />
    <!-- 二维码放大 -->
    <el-dialog title="设备二维码" :visible.sync="showQrCode" v-dialogDrag width="300px">
      <div class="qr_big">
        巡检项名称：<span>{{ rowInfo.firePatrolName }}</span>
      </div>
      <div class="qr_big" ref="printTest">
        <vue-qr
          :text="
            h5Url + rowInfo.firePatrolCode + '&firePatrolName=' + rowInfo.firePatrolName
          "
          :size="220"
          id="printTest"
          :margin="5"
        ></vue-qr>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="showQrCode = false">取消 </el-button>
        <el-button type="primary" @click="printTest">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import addItems from "../components/addItems";
import tableOption from "../config/tables";
import utils from "@src/common/utils";
import vueQr from "vue-qr";
export default {
  components: {
    addItems,
    vueQr,
  },
  data() {
    return {
      rowInfo: {},
      showQrCode: false,
      // utils.Cache.get("SYS_H5") +
      // http://10.40.146.150:8081/
      h5Url:
        // utils.Cache.get("SYS_H5")
        "http://10.40.146.150:8080" + "/#/pages/firePatrol_H5/create?firePatrolCode=", //firePatrolCode=20221227000005&=&firePatrolName=防火巡查测试1
      icon: require("../../../../src/common/assets/images/logo.png"), //二维码中间的图片,可以不设置
      option: tableOption(this),
      tableData: [],
      searchForm: {},
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  created() {},
  mounted() {
    this.getList();
    // console.log(utils.Cache.get("SYS_H5"));
  },
  methods: {
    handleUpdateStatus(row) {
      let newStatus = row.status;
      row.status = row.status == 2 ? "1" : "2";
      console.log(row);
      this.$confirm(`确定要${newStatus === 2 ? "启用" : "禁用"}此巡检项吗`, "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            firePatrolCode: row.firePatrolCode,
            status: newStatus,
          };
          this.$fetch(api.updateFirePatrolStatus, params).then((res) => {
            if (res.success) {
              this.$message({
                showClose: false,
                message: `${newStatus === 2 ? "启用" : "禁用"}成功`,
                type: "success",
                duration: 2000,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    printTest() {
      let qrSrc = this.$refs.printTest.getElementsByTagName("img")[0].src;
      let newWin = window.open("");
      newWin.document.body.innerHTML = `<img src='${qrSrc}' />`;
      newWin.document.close(); //在IE浏览器中使用必须添加这一句
      newWin.focus(); //在IE浏览器中使用必须添加这一句
      setTimeout(() => {
        newWin.print(); //打印
        newWin.close(); //关闭窗口
      }, 100);
      // window.document.body.innerHTML = `<img src='${qrSrc}' />`;
      // window.print(); //打印
    },
    showCode(rowInfo) {
      // console.log(this.h5Url+rowInfo.firePatrolCode+'&firePatrolName='+rowInfo.firePatrolName)
      this.showQrCode = true;
      this.rowInfo = rowInfo;
    },
    handleUpdate() {
      this.getList();
    },
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    getList() {
      let params = {
        ...this.searchForm,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.$fetch(api.getFirePatrolItems, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取巡检项列表失败");
        }
      });
    },
    handleAdd() {
      this.$refs.refAddItems.showPanel = true;
    },
    getDetail(row) {
      return new Promise((resolve) => {
        this.$fetch(api.detailFirePatrolItems, {
          firePatrolCode: row.firePatrolCode,
        }).then((res) => {
          resolve(res);
        });
      });
    },
    handleEdit(row) {
      this.getDetail(row).then((res) => {
        if (!res.success) {
          this.$message.error("获取详情失败");
          return;
        }
        this.$refs.refAddItems.showPanel = true;
        let info = res.returnObj;
        this.$refs.refAddItems.form = {
          firePatrolName: info.firePatrolName,
          status: Number(info.status),
          desc: info.desc,
          firePatrolItemList: info.firePatrolItemList,
        };
        this.$refs.refAddItems.tableData = info.firePatrolItemList;
        this.$refs.refAddItems.firePatrolCode = info.firePatrolCode;
        this.$refs.refAddItems.pageStates = "edit";
      });
    },
    handleView(row) {
      this.getDetail(row).then((res) => {
        if (!res.success) {
          this.$message.error("获取详情失败");
          return;
        }
        this.$refs.refAddItems.showPanel = true;
        let info = res.returnObj;
        this.$refs.refAddItems.form = {
          firePatrolName: info.firePatrolName,
          status: Number(info.status),
          desc: info.desc,
          firePatrolItemList: info.firePatrolItemList,
        };
        this.$refs.refAddItems.tableData = info.firePatrolItemList;
        this.$refs.refAddItems.firePatrolCode = info.firePatrolCode;
        this.$refs.refAddItems.pageStates = "view";
      });
    },
    handleDel(row) {
      const params = {
        firePatrolCode: row.firePatrolCode,
      };
      this.$confirm("您确定删除该巡查项吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.delFirePatrolItems, params).then((response) => {
          if (response && response.success) {
            this.getList();
            this.$message.success("操作成功");
          } else {
            this.$message.error(response.msgContent || "删除失败");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.firePatrol {
  &__wrap {
    .qr_big {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
    }
  }
}
</style>
